import {
  CANDIDATE_PROFILE_DETAILS_REQUEST,
  CANDIDATE_PROFILE_DETAILS_FAIL,
  CANDIDATE_PROFILE_DETAILS_SUCCESS
} from "../constants/AuthConstant";

import axios from "axios";

const baseUrl = process.env.REACT_APP_API_PATH;

// ------------------------------
// Existing Success Action
// ------------------------------
export const loadAllDetailsPre = (data) => ({
  type: CANDIDATE_PROFILE_DETAILS_SUCCESS,
  result: data,
  payload: false,
  loading: false,
  msg: "SUCCESS",
});

// ------------------------------
// NEW V2 Success Action
// ------------------------------
export const loadCandidateProfileV2 = (data) => ({
  type: CANDIDATE_PROFILE_DETAILS_SUCCESS,
  result: data,
  payload: false,
  loading: false,
  msg: "SUCCESS",
});

// ------------------------------
// Existing Candidate Profile
// ------------------------------
export const CandidateProfile = (id) => {
  return async (dispatch) => {
    dispatch({
      type: CANDIDATE_PROFILE_DETAILS_REQUEST,
      payload: true,
    });

    try {
      const res = await axios.get(`${baseUrl}/ebench/get_Candidate`, {
        params: { id },
        headers: { "content-type": "application/json" },
      });

      dispatch(loadAllDetailsPre(res.data));

      const isTeamMember = res?.data?.data?.isTeamMember;
      localStorage.setItem("isTeamMember", isTeamMember);

      return Promise.resolve(res.data);
    } catch (error) {
      dispatch({
        type: CANDIDATE_PROFILE_DETAILS_FAIL,
        payload: false,
        error,
        msg: "Failed to load the information",
      });

      return Promise.reject(error);
    }
  };
};

// ------------------------------
// ✅ NEW Candidate Profile V2
// ------------------------------
export const candidateProfilev2 = (id) => {
  return async (dispatch) => {
    dispatch({
      type: CANDIDATE_PROFILE_DETAILS_REQUEST,
      payload: true,
    });

    try {
      const res = await axios.get(`${baseUrl}/ebench/get_Candidate_v2`, {
        params: { candidateId:id },
        headers: { "content-type": "application/json" },
      });
      dispatch(loadCandidateProfileV2(res.data));
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch({
        type: CANDIDATE_PROFILE_DETAILS_FAIL,
        payload: false,
        error,
        msg: "Failed to load candidate profile",
      });

      return Promise.reject(error);
    }
  };
};
